import type { ReactNode } from "react";
import { useInterviewFlowState } from "@/features/interviewFlow";
import { useCandidateDeviceCheck } from "./useCandidateDeviceCheck";
import { LaptopRequiredScreen } from "./LaptopRequiredScreen";

interface CandidateDeviceGuardProps {
  children: ReactNode;
}

export function CandidateDeviceGuard({ children }: CandidateDeviceGuardProps) {
  const { validationData } = useInterviewFlowState();
  const { isMobileOrTablet, deviceType, isWindowTooSmall } =
    useCandidateDeviceCheck();

  const isPanelist = validationData?.role === "panel";

  if (!isPanelist && isMobileOrTablet) {
    return (
      <LaptopRequiredScreen
        deviceType={deviceType}
        isWindowTooSmall={isWindowTooSmall}
      />
    );
  }

  return <>{children}</>;
}
